import React, { useContext, useState } from 'react';
import styles from './index.module.scss';
import OptimizeEngine from './components/OptimizeEngine';
import { isNil } from 'lodash-es';
import {
  formatCarbon,
  formatCarbonEmissions,
  formatCarbonTotCO2,
  formatPower,
  judgeOverZero,
  keepPercentTwoLine,
  keepTwoAbsOrLine,
  keepTwoOrLine,
  keepTwoOrLineAbs,
} from '../../utils';
import { ShareDataContext } from '../..';
import bg from '../../imgs/bg2x.png';
import bgpart from '../../imgs/yuanqu.png';
import city_elec from '../../imgs/city_elec.png';
import pv from '../../imgs/pv.png';
import load from '../../imgs/load.png';
import bsa from '../../imgs/bsa.png';
import { V2MicrogridOverviewGetBsaTodayInfoPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import SVGDataBox from '../SVGDataBox';
import SVGBsaDataBox from '../SVGBsaDataBox';
import CenterBottomBox from '../CenterBottomBox';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';

const CenterBox = () => {
  const { newEnergyData, dataExit, isSmallScreen } = useContext(ShareDataContext);
  const [bsaData, setBsaData] = useState<V2MicrogridOverviewGetBsaTodayInfoPostResponse>(); // bsaId
  const hasPermission = useHasPermission(PermissionsType.B_OPTIMIZATIONENGINE); // 优化引擎

  const rotate = (dy: number, dx: number) => {
    let angle = (Math.atan2(dy, dx) * 180) / Math.PI;

    if (angle > 90 || angle < -90) {
      angle += 180;
    }
    return angle;
  };

  console.log(
    111,
    formatCarbonTotCO2(newEnergyData?.loadInfo?.todayConsumption).value as number,
    formatCarbonEmissions(newEnergyData?.loadInfo?.todayConsumption! * 0.1229).value as number,
    (formatCarbonTotCO2(newEnergyData?.loadInfo?.todayConsumption).value as number) /
      (formatCarbonEmissions(newEnergyData?.loadInfo?.todayConsumption! * 0.1229).value as number)
  );

  return (
    <div className={styles.svg_background}>
      {/* 背景图片撑满整个屏幕 */}
      <img src={bg} alt="background" className={styles.bg_image} />

      {/* SVG层 - 固定位置的元素 */}
      <svg viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid meet" className={styles.svg_layer}>
        <defs>
          {/* 流动光带渐变 */}
          <linearGradient id="flowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            {/* <stop offset="0%" stopColor="transparent" />
                        <stop offset="50%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="transparent" /> */}
            <stop offset="0%" stopColor="transparent" />
            <stop offset="10%" stopColor="#78FF98" stopOpacity="0.4" />
            <stop offset="50%" stopColor="#43EFFF" stopOpacity="1" />
            <stop offset="90%" stopColor="transparent" stopOpacity="0.1" />
            <stop offset="100%" stopColor="transparent" />
          </linearGradient>
        </defs>

        {/* 市电--主 */}
        <path d="M650 480 L520 560 L660 640" className={styles.flow_tube} />
        <path d="M650 480 L520 560 L660 640" className={styles.flow_base} stroke="url(#flowGradient)" />
        <path
          d="M650 480 L520 560 L660 640"
          className={`${isNil(newEnergyData?.gridInfo?.power) ? styles.stop_light : styles.flow_light} ${
            judgeOverZero(newEnergyData?.gridInfo?.power) ? styles.reverse : ''
          }`}
          stroke="url(#flowGradient)"
        />
        {/* 光伏--主 */}
        <path d="M760 520 L980 650" className={styles.flow_tube} />
        <path d="M760 520 L980 650" className={styles.flow_base} stroke="url(#flowGradient)" />
        <path
          d="M760 520 L980 650"
          className={`${isNil(newEnergyData?.pvInfo?.generationPower) ? styles.stop_light : styles.flow_light} ${
            judgeOverZero(newEnergyData?.pvInfo?.generationPower) ? styles.reverse : ''
          }`}
          stroke="url(#flowGradient)"
        />
        {/* 负载--主 */}
        <path d="M880 420 L980 480 L1030 450 L1292 600" className={styles.flow_tube} />
        <path d="M880 420 L980 480 L1030 450 L1292 600" className={styles.flow_base} stroke="url(#flowGradient)" />
        <path
          d="M880 420 L980 480 L1030 450 L1292 600"
          className={`${isNil(newEnergyData?.loadInfo?.powerDemand) ? styles.stop_light : styles.flow_light} ${
            judgeOverZero(newEnergyData?.loadInfo?.powerDemand) ? '' : styles.reverse
          }`}
          stroke="url(#flowGradient)"
        />
        {/* 储能--主 */}
        <path d="M910 280 L980 235 L1200 360" className={styles.flow_tube} />
        <path d="M910 280 L980 235 L1200 360" className={styles.flow_base} stroke="url(#flowGradient)" />
        <path
          d="M910 280 L980 235 L1200 360"
          className={`${isNil(bsaData?.power) ? styles.stop_light : styles.flow_light} ${
            judgeOverZero(bsaData?.power) ? '' : styles.reverse
          }`}
          stroke="url(#flowGradient)"
        />

        <image href={bgpart} x="510" y="210" width="574" height="420" />
        <image href={city_elec} x="550" y="530" width="260" height="254" />
        <image href={pv} x="850" y="570" width="260" height="201" />
        <image href={load} x="1150" y="480" width="260" height="228" />
        <image href={bsa} x="1150" y="280" width="260" height="202" />

        {/* 市电,光伏,负载,储能 */}
        <g transform={`translate(${585}, ${520}) rotate(${rotate(80, -130)})`}>
          <foreignObject
            x={-90}
            y={-40} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.line_data}>
              <div className={styles.label}>
                {judgeOverZero(newEnergyData?.gridInfo?.power) ? '净下网' : '上网'}功率:
              </div>
              <div className={styles.value}>{keepTwoOrLineAbs(newEnergyData?.gridInfo?.power)}kW</div>
            </div>
          </foreignObject>
          <foreignObject
            x={0}
            y={240} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.desc}>市电</div>
          </foreignObject>
          <foreignObject
            x={270}
            y={390} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.desc}>光伏</div>
          </foreignObject>
          <foreignObject
            x={550}
            y={495} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.desc}>负载</div>
          </foreignObject>
          <foreignObject
            x={680}
            y={300} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.desc}>储能</div>
          </foreignObject>
        </g>

        {/* 光伏，负载，储能 */}
        <g transform={`translate(${870}, ${570}) rotate(${rotate(130, 220)})`}>
          {/* 光伏 */}
          <foreignObject
            x={-60}
            y={-20} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.line_data}>
              <div className={styles.label}>发电功率：</div>
              <div className={styles.value}>
                {keepTwoOrLine(newEnergyData?.pvInfo?.generationPower)}
                kW
              </div>
            </div>
          </foreignObject>

          {/* 负载 */}
          <foreignObject
            x={90}
            y={-170} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.line_data}>
              <div className={styles.label}>用电负荷：</div>
              <div className={styles.value}>{keepTwoOrLine(newEnergyData?.loadInfo?.powerDemand)}kW</div>
            </div>
          </foreignObject>
          {/* 储能 */}
          <foreignObject
            x={-60}
            y={-330} // 控制在线上方的距离
            width={160}
            height={60}
          >
            <div className={styles.line_data}>
              <div className={styles.label}>{judgeOverZero(bsaData?.power) ? '充电' : '放电'}功率：</div>
              <div className={styles.value}>{keepTwoAbsOrLine(bsaData?.power)}kW</div>
            </div>
          </foreignObject>
        </g>

        {/* 新能源占比 - 固定位置 */}
        <foreignObject x="530" y="140" width="300" height="200">
          <div className={styles.rate_box}>
            <div className={styles.rate_label}>新能源占比</div>
            <div className={styles.rate_value}>{keepPercentTwoLine(newEnergyData?.newEnergyRate)}%</div>
          </div>
        </foreignObject>

        {/* 光伏 - 源 */}
        {/* 留出左上角标签的空间：左边37px + 宽度56px，上边30px + 高度56px */}
        <foreignObject x="800" y="728" width="350" height="250" overflow="visible">
          <SVGDataBox
            leftTitle={'源'}
            data={[
              {
                label: '光伏容量',
                value: newEnergyData?.pvInfo?.capacity?.toFixed(2) || '--',
                unit: 'kW',
                color: 'rgba(255,255,255,0.85)',
              },
              {
                label: '今日发电量',
                value: formatPower(newEnergyData?.pvInfo?.todayGeneration).value,
                unit: formatPower(newEnergyData?.pvInfo?.todayGeneration).unit,
                color: '#16DD8E',
              },
            ]}
          />
        </foreignObject>

        {/* 市电 - 网 */}
        <foreignObject x="500" y="728" width="350" height="250" overflow="visible">
          <SVGDataBox
            leftTitle={'网'}
            data={[
              {
                label: '今日上网电量',
                value: formatPower(newEnergyData?.gridInfo?.feedIn).value,
                unit: formatPower(newEnergyData?.gridInfo?.feedIn).unit,
                color: '#16DD8E',
              },
              {
                label: '今日下网电量',
                value: formatPower(newEnergyData?.gridInfo?.purchased).value,
                unit: formatPower(newEnergyData?.gridInfo?.purchased).unit,
                color: '#00ADFF',
              },
            ]}
          />
        </foreignObject>

        {/* 负载 - 荷 */}
        <foreignObject x="1120" y="680" width="350" height="250" overflow="visible">
          <SVGDataBox
            leftTitle={'荷'}
            data={[
              {
                label: '今日用电量',
                value: formatPower(newEnergyData?.loadInfo?.todayConsumption).value,
                unit: formatPower(newEnergyData?.loadInfo?.todayConsumption).unit,
                color: '#16DD8E',
              },
              {
                label: '碳排',
                value: formatCarbonTotCO2(newEnergyData?.loadInfo?.todayConsumption).value,
                unit: formatCarbonTotCO2(newEnergyData?.loadInfo?.todayConsumption).unit,
                color: '#16DD8E',
              },
              {
                label: '单位能耗碳排',
                value: !isNil(newEnergyData?.loadInfo?.todayConsumption) ? (0.5703 / 0.1229).toFixed(2) : '-',
                unit: !isNil(newEnergyData?.loadInfo?.todayConsumption) ? 'tCO2e/kgce' : '-',
                color: '#16DD8E',
                wrapUnit: true,
              },
            ]}
          />
        </foreignObject>

        {/* 储能 - 储 */}
        <foreignObject x="1040" y="118" width="350" height="300" overflow="visible">
          <SVGBsaDataBox leftTitle="储" dataExit={dataExit} getBsaData={val => setBsaData(val)} />
        </foreignObject>
      </svg>

      {/* 优化引擎 - 放在中间 */}
      {hasPermission && (
        <div className={styles.optimize_engine_wrapper}>
          <OptimizeEngine />
        </div>
      )}

      {/* 近七日报警-底部中间 */}
      <div className={styles.center_bottom_box}>
        <CenterBottomBox />
      </div>
    </div>
  );
};

export default CenterBox;
